import Enum from './Enum';

export const urlLabel = Enum({
  verifyPatient: 'verify-email',
  home: '',
  login: 'login',
  register: 'register',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  resetPasswordOldUser: 'reset-password-old-user',
  logout: 'logout',
  accountSettings: 'settings',
  chatSample: 'chat-sample',
  profileManagement: 'profile-management',
  workoutManagement: 'workout-management',
  excutePaypal: 'excutePaypal',
  internalLogin: 'internal/login',
  internalRegister: 'internal/register',
  clinicManagementMenu: 'clinic-set-up-menu',
  userPermission: 'user-permission',
  deepLink: 'deep-link',
  screenQueue: 'queue',
  resultInbox: 'result-inbox',
  exportIrReport: 'export-ir-report',
  swabberManagement: 'swabber',
  bookingManagementSupervisedArt: 'appointment-config-supervised-art',
  appointmentsMenu: 'appointments-menu',

  // Old link Project
  projects: 'projects',
  adminTools: 'projects/admin-tools',
  createProject: 'projects/company-management/new-project',
  projectManage: 'projects/company-management/edit-project',
  editProject: 'projects/company-management/edit-project/:projectName',
  editSequenceStations: 'projects/company-management/edit-sequence-stations',
  stationManagement: 'projects/stations',
  createStation: 'projects/stations/create',
  editStation: 'projects/stations/:stationID',
  timeSlotTemplate: 'projects/admin-tools/time-slot-template',
  timeSlotTemplateCreate:
    'projects/admin-tools/time-slot-template/new-time-slot-template',
  timeSlotTemplateEdit:
    'projects/admin-tools/time-slot-template/edit-time-slot-template',
  consentManagement: 'projects/admin-tools/consent-management',
  createConsent: 'projects/admin-tools/consent-management/new-consent',
  editConsent: 'projects/admin-tools/consent-management/:consentId',
  // Old link Life-survey
  surveyManagement: 'life-survey',
  createSurvey: 'life-survey/new-life-survey',
  editSurvey: 'life-survey/edit-life-survey',
  // Old Link Services
  services: 'services',
  // testManagement: 'services/tests',
  testForm: 'services/tests/new-test-form',
  testEditForm: 'services/tests/:name',
  measurementManagement: 'services/measurements',
  measurementForm: 'services/measurements/new-measurement-form',
  measurementEditForm: 'services/measurements/:name',
  procedureManagement: 'services/procedures',
  procedureForm: 'services/procedures/new-procedure-form',
  procedureEditForm: 'services/procedures/:name',
  radiologyManagement: 'services/radiologies',
  radiologyForm: 'services/radiologies/new-radiology-form',
  radiologyEditForm: 'services/radiologies/:name',
  vaccinationManagement: 'services/vaccinations',
  vaccinationForm: 'services/vaccinations/new-vaccination-form',
  vaccinationEditForm: 'services/vaccinations/:name',
  reviewManagement: 'services/reviews',
  reviewnForm: 'services/reviews/new-review-form',
  reviewEditForm: 'services/reviews/:name',
  profileAndTests: 'services',
  healthProfiles: 'services/profiles',
  healthProfilesForm: 'services/profiles/create-new-profile',
  healthProfilesEditForm: 'services/profiles/:name',
  healthProfilesStatements: 'services/profiles/edit-conditions',
  healthPackages: 'services/packages',
  healthPackagesForm: 'services/packages/create-new-package',
  healthPackagesEditForm: 'services/packages/:packageName',
  profilesAndTests: 'services',
  statementManagement: 'services/statements',
  motherhoodStatement: 'services/motherhood-statements',
  screeningQuestionnaires: 'services/screening-questionnaires',

  // Old link Appointments Heath Screening
  appointments: 'appointments-heath-screening',
  checkInPatientInfo:
    'appointments-heath-screening/patient-registration-information',
  assignConsentForm: 'appointments-heath-screening/select-consent-form',
  detailAppointment: 'appointments-heath-screening/detail-appointment',
  surveyDetail: 'appointments-heath-screening/lifestyle-survey',

  /* ========= New Router ========= */
  /* All-users */
  userDetails: 'all-users',
  editUserDetail: 'all-users/user-details',

  /* Teleconsult */
  // patientManagement: 'teleconsult/patient-details',
  waitingRoom: 'teleconsult/queue',
  appointmentManagement: 'teleconsult/appointments',
  meetingHistory: 'teleconsult/all-teleconsults-dr',
  consultList: 'teleconsult/all-teleconsults',

  bookingManagement: 'teleconsult/setup/appointments',
  doctorManagement: 'teleconsult/setup/doctors',
  caManagement: 'teleconsult/setup/ce',
  promotion: 'teleconsult/setup/promo-code',

  mhsManagement: 'teleconsult/mhs-management',
  teleconsultAnalytics: 'teleconsult/analytics',

  /* Clinic */
  clinicManagement: 'clinic/setup/locations',
  clinicServices: 'clinic/setup/services',
  queueManagement: 'clinic/queue-request',
  clinicAppointments: 'clinic/appointments',
  queueClosure: 'clinic/queue-closure',

  /* Health-Screening */
  // Upcomming
  upcomingHealthScreening: 'health-screening/appointments-today',
  upcomingEditAppointment:
    'health-screening/appointments-today/edit-appointment',
  // All Screenings
  allScreenings: 'health-screening/all-screenings',
  aSEditAppointment: 'health-screening/all-screenings/edit-appointment',
  aSviewPatientRegistration:
    'health-screening/all-screenings/patient-registration',
  aSRegisterPatient: 'health-screening/all-screenings/register-patient',
  aSEditPackage:
    'health-screening/all-screenings/register-patient/edit-package',
  aSCreateAppointment: 'health-screening/all-screenings/create-new-appointment',
  aSScreeningProgress: 'health-screening/all-screenings/screening-progress',
  aSPatientRegistration:
    'health-screening/all-screenings/screening-progress/patient-registration',
  aSCreateFollowUpAppointment:
    'health-screening/all-screenings/create-follow-up-appointment',
  aSRescheduleAppointment:
    'health-screening/all-screenings/reschedule-appointment',
  // Onsite Ops
  orderListExport: 'health-screening/onsite-ops/lab-e-order',
  siteClosingReport: 'health-screening/onsite-ops/closing-report',
  ageqReport: 'health-screening/onsite-ops/ageq-report',
  // Setup
  createCompany: 'health-screening/setup/company/create-new-company',
  editCompany: 'health-screening/setup/company/company-information',
  locationManagement: 'health-screening/setup/locations',
  locationManagementCreate:
    'health-screening/setup/locations/create-new-location',
  locationManagementEdit: 'health-screening/setup/locations/edit-location',
  companyManagement: 'health-screening/setup/company',
  configPackages: 'health-screening/setup/screening-packages',
  configProfiles: 'health-screening/setup/test-profiles',
  configOtherServices: 'health-screening/setup/other-services',
  configLifestyleSurvey: 'health-screening/setup/lifestyle-survey',
  configConsentForm: 'health-screening/setup/consent-form',
  importHSAppointments: 'health-screening/setup/import-hs-appointments',
  batchVaccinationRecordUpdate:
    'health-screening/setup/batch-vaccination-record-update',
  platoFileDownload: 'health-screening/setup/plato-file-download',

  // Admin
  configTimeslotTemplate: 'health-screening/admin/timeslot-template',
  configMotherhood: 'health-screening/admin/motherhood-statement',
  // Configuration
  configuration: 'health-screening/configuration',

  testManagement: 'health-screening/configuration/tests',
  configStations: 'health-screening/setup/stations',

  // Backroom
  backroomModule: 'health-screening/backroom/results-upload',
  resultsReviewModule: 'health-screening/backroom/results-review',
  resultsReviewDetail: 'health-screening/backroom/results-review/:name',
  escalationWorklist: 'health-screening/escalation-worklist',

  // Corporate Report
  previewDownloadCRReport: 'project-cr',
  previewDownloadCRConsolidationReport: 'project-cr-consolidation',
  corporateReport: 'health-screening/corporate-reports',

  // Plato
  downloadPlatoFiles: 'download-plato-files',

  /* Support */
  // Admin
  adminManagement: 'support/admin/users',
  rolesManagement: 'support/admin/roles',
  importMassUser: 'support/admin/import-mass-user',
  // Customer Care Support
  apiSupport: 'support/customer-care-support/account-support',
  stuckAccounts: 'support/customer-care-support/restricted-accounts',
  // Marketing
  bannerManagement: 'support/marketing/banners',
  marketingMessages: 'support/marketing/app-notifications',

  deletionRequest: 'minc-admin/deletion-worklist',
  labResult: 'minc-admin/lab-result',
  angelNudgeManagement: 'support/angel-nudge-management',
  ecommerceManagement: 'support/ecommerce',

  /* Telefit */
  categoryManagement: 'telefit/workout/category-management',
  livestreamManagement: 'telefit/workout/livestream-management',
  livestreamSectionDetail: 'telefit/workout/livestream-management/:id',
  onDemandManagement: 'telefit/workout/on-demand-management',
  studioClassesManagement: 'telefit/workout/studio-classes-management',

  upcomingWorkoutManagement: 'telefit/upcoming-workouts',
  studioManagement: 'telefit/studio-management',
  trainerManagement: 'telefit/trainer-management',
  userManagement: 'telefit/internal-trainer-user-management',

  /* Telecounsel */
  telecounselQueue: 'counselling/queue',
  telecounselAllCounsels: 'counselling/all-counsellings',
  telecounselAppointments: 'counselling/appointments',
  telecounselAppointmentConfig: 'counselling/setup/appointments',
  telecounseRMCounsellors: 'counselling/setup/counsellors',
  telecounseRMCounsellorExecutives: 'counselling/setup/ce',
  telecounselPromotion: 'counselling/setup/company-code',

  /* Teleconsult Now */
  patientLogin: 'teleconsult',
  patientRegister: 'teleconsult/register',
  teleconsultNow: 'teleconsult/teleconsult-now',
  completeProfile: 'teleconsult/complete-profile',
  patientForgotPassword: 'teleconsult/forgot-password',

  acknowledgeResult: 'acknowledge-abnormal-result',
  nudgeAngelsEmailAcknowledge: 'nudge-angels/email-acknowledge',
  verifySingpassSuccess: 'login-success',
});
